module.exports = __webpack_public_path__ + "img/visualsoft.d9d9fa4f.svg";